import React from 'react'
import PaymentBox from '../components/PaymentBox'
import { useLocation } from 'react-router-dom';
import Error from './Error';

const Home = () => {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const token = queryParams.get('token');

  return (
    <main>
      {
        token
        ?
        <PaymentBox 
          token={token}
        />
        :
        <Error />
      }
    </main>
  )
}

export default Home